var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "slideout-container",
      class: { show: _vm.show },
      on: { click: _vm.toggleSlideout }
    },
    [
      _c(
        "div",
        {
          staticClass: "slideout",
          class: { inverse: _vm.inverse },
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", {
            staticClass: "close",
            on: { click: _vm.toggleSlideout }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "slideout-content" }, [_vm._t("default")], 2)
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }